import React from 'react';
import { FaTools, FaUserCheck, FaBolt, FaShieldAlt } from 'react-icons/fa';
import Classes from './WhyChooseUs.module.css';
import { SITE } from '../../../../../data/siteConfig';

const features = [
    { icon: <FaTools />, title: 'Versatile Solutions', text: 'From minor repairs to full remodels, we’re a one-stop shop for everything your home needs.' },
    { icon: <FaUserCheck />, title: 'Reliable Craftsmanship', text: 'A skilled, experienced team that delivers dependable results and cleans up when the job is done.' },
    { icon: <FaBolt />, title: 'Prompt Service', text: 'We respect your time: on-time arrivals, clear communication and efficient work that fits your schedule.' },
    { icon: <FaShieldAlt />, title: 'Warranty on All Work', text: 'We stand behind every job with a satisfaction guarantee and warranty for your peace of mind.' },
];

export default function WhyChooseUs() {
    return (
        <section id="why-us" className="section section-gray">
            <div className={`container ${Classes.grid}`}>
                <div className={Classes.media}>
                    <img src="/assets/images/2.webp" srcSet="/assets/images/2-800.webp 800w, /assets/images/2.webp 1600w" sizes="(max-width: 900px) 100vw, 600px" alt="Kitchen remodel with navy island and marble countertop" loading="lazy" className={Classes.imgMain} />
                    <img src="/assets/images/4.webp" srcSet="/assets/images/4-800.webp 800w, /assets/images/4.webp 1600w" sizes="(max-width: 900px) 50vw, 300px" alt="Bathroom remodel with glass walk-in shower" loading="lazy" className={Classes.imgSmall} />
                    <div className={Classes.stat}>
                        <strong>20+</strong>
                        <span>Years serving<br />{SITE.region}</span>
                    </div>
                </div>

                <div>
                    <div className="eyebrow">Why Choose Us</div>
                    <h2 className="section-title">Reliable, Professional, and Always Done Right</h2>
                    <p className="section-lead">
                        Top-quality workmanship, honest pricing and dependable service that homeowners across {SITE.region} trust.
                    </p>

                    <div className={Classes.features}>
                        {features.map((f) => (
                            <div key={f.title} className={Classes.feature}>
                                <span className={Classes.icon}>{f.icon}</span>
                                <div>
                                    <h3>{f.title}</h3>
                                    <p>{f.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark">
                        Book an Appointment
                    </a>
                </div>
            </div>
        </section>
    );
}
